import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { experiences, getServiceSlug } from '../../data/constants'; 

const ServiceDetailContainer = styled.div`
  padding: 56px 20px 72px;
  max-width: 980px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 42px;
  font-weight: 700;
  text-align: center;
  color: #28ac30; /* Primary green color */
  background: linear-gradient(90deg, #28ac30, #85d67f);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 1px 2px 4px rgba(0, 0, 0, 0.15);
  margin-bottom: 30px;

  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

const Description = styled.p`
  font-size: 17px;
  line-height: 1.75;
  color: #333;
  margin: 0 0 18px;
  text-align: left;
`;

const SectionIntro = styled.p`
  font-size: 18px;
  font-weight: 600;
  color: #235b27;
  margin: 34px 0 18px;
`;

const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  margin-top: 20px;
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  line-height: 1.35;
  color: #28ac30;
  margin: 0 0 10px;
`;

const ServicesList = styled.ul`
  list-style-type: disc;
  padding-left: 20px;
  font-size: 16px;
  line-height: 1.65;
  color: #555;
  text-align: left;
  margin: 0;
`;

const ServiceDetail = () => {
  const { slug } = useParams(); 
  const experience = experiences.find(
    (exp) => getServiceSlug(exp) === slug || exp.id === Number(slug)
  ); 

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [slug]);

  if (!experience) {
    return <p style={{ textAlign: 'center', fontSize: '18px', color: '#888' }}>No details found</p>;
  }

  return (
    <ServiceDetailContainer>
      <Title>{experience.role?.trim()}</Title>
      {Array.isArray(experience.desc) ? (
        experience.desc.map((paragraph, index) => (
          <Description key={index}>{paragraph}</Description>
        ))
      ) : (
        experience.desc && <Description>{experience.desc}</Description>
      )}

      {experience.sections?.length > 0 ? (
        <>
          {experience.sectionsIntro && <SectionIntro>{experience.sectionsIntro}</SectionIntro>}
          <Sections>
            {experience.sections.map((section) => (
              <section key={section.title}>
                <SectionTitle>{section.title}</SectionTitle>
                <ServicesList>
                  {section.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ServicesList>
              </section>
            ))}
          </Sections>
        </>
      ) : experience.skills && experience.skills.length > 0 ? (
        <ServicesList>
          {experience.skills.map((skill, index) => (
            <li key={index}>{skill}</li>
          ))}
        </ServicesList>
      ) : (
        <p style={{ color: '#888', textAlign: 'left' }}>No details available yet</p>
      )}
    </ServiceDetailContainer>
  );
};

export default ServiceDetail;
